import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import api from "../services/api";

export default function Navbar() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [userData, setUserData] = useState({ name: "", email: "", phone: "", position: null });
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (token) {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      Promise.allSettled([
        api.get("/users/me", config),
        api.get("/rankings", config)
      ]).then(([resU, resR]) => {
        if (resU.status === 'fulfilled') {
          const { name, email, phone } = resU.value.data;
          let position = null;
          if (resR.status === 'fulfilled') {
            const myIndex = resR.value.data.findIndex(u => u.name === name);
            if (myIndex !== -1) position = myIndex + 1;
          }
          setUserData({ name, email, phone, position });
        }
      });
    }

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [token]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <header className="fixed top-0 left-0 w-full z-[100] bg-[#0052cc] border-b border-white/30 shadow-2xl h-16">
      <div className="max-w-7xl mx-auto px-6 h-full">
        <div className="flex items-center justify-between h-full relative">
          
          {/* IZQUIERDA: LOGO */}
          <div className="flex items-center">
            <Link to="/" className="relative z-[110]">
              <img
                src="/golistico-logo.png"
                alt="Golístico"
                className="h-16 md:h-20 w-auto object-contain drop-shadow-2xl absolute -top-5 md:-top-6 left-0 transition-transform hover:scale-105"
              />
              <div className="w-24 md:w-32" />
            </Link>

            <nav className="hidden md:flex items-center gap-6 ml-4">
              <Link to="/dashboard" className="text-[11px] font-black text-white hover:text-yellow-400 transition-colors uppercase tracking-widest">
                Predicciones
              </Link>
              <Link to="/rules" className="text-[11px] font-black text-white hover:text-yellow-400 transition-colors uppercase tracking-widest">
                Reglas de Juego
              </Link>
            </nav>
          </div>

          {/* DERECHA: AUTH O PERFIL */}
          <div className="flex items-center gap-4" ref={dropdownRef}>
            {!token ? (
              <div className="flex items-center gap-3">
                {/* BOTÓN REGÍSTRATE (ESTILO DORADO DESTACADO) */}
                <Link 
                  to="/register" 
                  className="relative group overflow-hidden px-5 py-2 rounded-full bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-600 shadow-lg transition-all hover:scale-105 active:scale-95 border-b-2 border-yellow-700"
                >
                  <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:animate-[shimmer_2s_infinite] pointer-events-none"></div>
                  <span className="relative text-blue-900 font-black text-[10px] uppercase tracking-widest">
                    Regístrate
                  </span>
                </Link>

                {/* BOTÓN INGRESAR (ESTILO MINIMALISTA) */}
                <Link 
                  to="/login" 
                  className="px-5 py-2 rounded-full border-2 border-white/30 text-white font-black text-[10px] uppercase tracking-widest hover:bg-white/10 transition-all active:scale-95"
                >
                  Ingresar
                </Link>
              </div>
            ) : (
              <div className="relative flex items-center gap-3">
                
                {/* INSIGNIA DE POSICIÓN */}
                <div className="flex items-center bg-blue-900/40 border-2 border-white/20 rounded-full p-1 pr-4 shadow-xl backdrop-blur-sm group cursor-default">
                  <div className="relative">
                    <div className="absolute inset-0 bg-yellow-400 blur-md opacity-30 group-hover:opacity-60 animate-pulse transition-opacity"></div>
                    <div className="relative w-9 h-9 bg-gradient-to-br from-yellow-300 via-yellow-500 to-yellow-700 rounded-full flex items-center justify-center border-2 border-white shadow-md transform transition-transform group-hover:scale-110">
                      <span className="text-blue-950 font-black italic text-sm">
                        #{userData.position || '--'}
                      </span>
                      <div className="absolute inset-0 rounded-full overflow-hidden pointer-events-none">
                        <div className="absolute top-0 -left-[100%] w-full h-full bg-gradient-to-r from-transparent via-white/60 to-transparent skew-x-[-45deg] animate-[shimmer_4s_infinite]"></div>
                      </div>
                    </div>
                  </div>
                  <div className="ml-3 flex flex-col justify-center leading-none">
                    <span className="text-[7px] font-black text-white/50 uppercase tracking-widest">Ranking</span>
                    <span className="text-[10px] font-black text-white uppercase mt-1 tracking-tighter">Tu Puesto</span>
                  </div>
                </div>

                {/* BOTÓN PERFIL */}
                <button 
                  onClick={() => setShowDropdown(!showDropdown)}
                  className={`flex items-center gap-2 p-1 pr-3 rounded-full transition-all border-2 ${showDropdown ? 'border-yellow-400 bg-blue-700 shadow-lg' : 'border-white/20 bg-blue-800/40 hover:bg-blue-700'}`}
                >
                  <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white font-black text-xs shadow-md border border-white/30 uppercase">
                    {userData.name.charAt(0)}
                  </div>
                  <span className="text-[10px] font-black text-white uppercase tracking-tight hidden md:block">Mi Perfil</span>
                  <svg className={`w-3 h-3 text-white transition-transform ${showDropdown ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M19 9l-7 7-7-7" /></svg>
                </button>

                {/* DROPDOWN */}
                {showDropdown && (
                  <div className="absolute right-0 top-full mt-3 w-64 bg-white rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.4)] overflow-hidden animate-in fade-in zoom-in-95 duration-200 origin-top-right border border-slate-200">
                    <div className="p-5 bg-gradient-to-br from-[#0052cc] to-[#003d99] text-center">
                      <div className="w-14 h-14 bg-yellow-400 rounded-full mx-auto mb-2 flex items-center justify-center text-blue-900 text-xl font-black shadow-lg border-2 border-white">
                        {userData.name.charAt(0)}
                      </div>
                      <h4 className="text-sm font-black text-white uppercase truncate">{userData.name}</h4>
                      <p className="text-[9px] font-bold text-yellow-300 tracking-[0.2em] uppercase">Jugador Registrado</p>
                    </div>

                    <div className="p-4 space-y-4 bg-slate-50 border-b border-slate-100">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600 shadow-sm">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" strokeWidth="2.5"/></svg>
                        </div>
                        <div className="overflow-hidden">
                          <p className="text-[8px] font-black text-slate-400 uppercase tracking-tighter leading-none mb-1">Email</p>
                          <p className="text-[10px] text-slate-700 font-bold truncate">{userData.email}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-lg bg-green-100 flex items-center justify-center text-green-600 shadow-sm">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" strokeWidth="2.5"/></svg>
                        </div>
                        <div>
                          <p className="text-[8px] font-black text-slate-400 uppercase tracking-tighter leading-none mb-1">WhatsApp</p>
                          <p className="text-[10px] text-slate-700 font-bold">{userData.phone}</p>
                        </div>
                      </div>
                    </div>

                    <div className="p-2">
                      <button 
                        onClick={() => { navigate('/change-password'); setShowDropdown(false); }}
                        className="w-full flex items-center justify-between px-4 py-3 rounded-xl bg-blue-50 hover:bg-blue-600 text-blue-700 hover:text-white transition-all group"
                      >
                        <div className="flex items-center gap-3">
                          <span className="text-base group-hover:scale-110 transition-transform">🔑</span>
                          <span className="text-[10px] font-black uppercase tracking-tight">Seguridad</span>
                        </div>
                        <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" strokeWidth="3"/></svg>
                      </button>
                      <button 
                        onClick={handleLogout}
                        className="w-full flex items-center gap-3 mt-1 px-4 py-3 rounded-xl hover:bg-red-50 text-red-500 transition-all font-black text-[10px] uppercase"
                      >
                        🚪 Cerrar Sesión
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes shimmer {
          0% { left: -100%; }
          30% { left: 125%; }
          100% { left: 125%; }
        }
      `}} />
    </header>
  );
}